import { Radio, chakra } from '@aloft/toolkit-sui/chakra';
import { ColumnDef as ReactTableColumnDef } from '@tanstack/react-table';

import { IS_SELECTED_COLUMN_ID } from './constants';
import { TPTableSelectRow } from './types';

export function makeSingleSelectIsSelectedColumn<T>(
  shouldPinFirstRow: boolean,
  onRowSelect: TPTableSelectRow<T> | undefined,
): ReactTableColumnDef<T> {
  return {
    id: IS_SELECTED_COLUMN_ID,
    size: 32,
    cell: (cellCtx) => {
      const { row } = cellCtx;
      if (shouldPinFirstRow && row.index === 0) {
        // TODO
      }
      const isSelected = row.getIsSelected();
      const isDisabled = !row.getCanSelect();

      const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();

        if (isDisabled) return;
        if (isSelected) return;

        const nextState = !isSelected;
        onRowSelect?.(row.original, nextState);

        const toggleSelected = row.getToggleSelectedHandler();
        toggleSelected(event);
      };

      return (
        <chakra.span height="100%" display="flex" alignItems="center" justifyContent="center">
          <Radio isChecked={isSelected} isDisabled={isDisabled} onClick={handleClick} />
        </chakra.span>
      );
    },
  };
}
